function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M200.2 135c12.5-12.2 19.5-29.3 19.5-49.9 0-43-30.6-70.9-78-70.9S63.8 42 63.8 85c0 20.6 7 37.7 19.5 49.9C30.8 149.7 0 185.9 0 236.4v25.8h283.5v-25.8c0-50.5-30.8-86.7-83.3-101.4zM92.1 85c0-15.9 6.4-42.5 49.6-42.5s49.6 26.6 49.6 42.5-6.4 42.5-49.6 42.5c-43.1.1-49.6-26.6-49.6-42.5zM28.4 233.9c.7-24.7 11.1-44.1 31.1-57.5 19.9-13.4 48.4-20.5 82.3-20.5s62.4 7.1 82.3 20.5c20 13.4 30.4 32.7 31.1 57.5H28.4z",
  id: "User"
})));